import { NgModule } from '@angular/core';
import {Routes, RouterModule } from '@angular/router';
import {CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule } from "@angular/forms";

import {RxFormsModule} from "@rx/forms";
import {RxViewModule} from "@rx/view";
import {    RxTableModule} from "@rx/table";

import { AlertSearchComponent } from './alert-search.component'
import { ALERT_SEARCH_ROUTING } from './alert-search.routing'
import {AlertsService } from "../alerts.service";

@NgModule({
    imports: [
        ALERT_SEARCH_ROUTING ,
        CommonModule, RxViewModule, RxTableModule, RxFormsModule, FormsModule, ReactiveFormsModule,
		    ],
    declarations: [AlertSearchComponent ],
    exports: [RouterModule],
    providers: [AlertsService]
})
export class AlertSearchModule { }